// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2sGvU","savePackageButton":"ClientWallet_savePackageButton__34SM9"};